import React, { useEffect } from "react";
import styles from "./Home.module.css";
import { Link } from "react-router-dom";
import axios from "axios";
import HomeStats from "../components/HomeStats";

export default function Home() {
  const API = process.env.REACT_APP_API_URL || "http://localhost:8080";

  useEffect(() => {
    const warup = async () => {
      try {
        await axios.get(`${API}/api/warmup`);
      } catch (error) {
        console.log("error while warming up", error);
      }
    };
    warup();
  }, [API]);

  return (
    <div className={styles.pageWrapper}>
      {/* ✅ HERO SECTION */}
      <section className={styles.hero}>
        <div className={styles.overlay}></div>

        <div className={styles.heroContent}>
          <h1 className={styles.title}>BNI Brisk</h1>
          <p className={styles.subtitle}>
            Growing Businesses Through the Power of Referrals
          </p>

          <div className={styles.heroButtons}>
            <Link to="/members" className={styles.btnPrimary}>
              View Members
            </Link>
            <Link to="/about" className={styles.btnSecondary}>
              About BNI
            </Link>
          </div>
        </div>
      </section>

      {/* ✅ ABOUT SECTION */}
      <section className="container">
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>About BNI Brisk</h2>
          <p className={styles.sectionText}>
            BNI Brisk is a part of the world’s largest referral networking
            organization. Our chapter follows the{" "}
            <strong>Givers Gain® Philosophy</strong> — the more you give, the
            more you gain.
          </p>
        </div>
      </section>

      {/* ✅ WHY BNI SECTION */}
      <section className={styles.whyBniSection}>
        <h2 className={styles.sectionTitle}>Why Choose BNI?</h2>

        <div className={styles.whyGrid}>
          <div className={styles.whyCard}>
            <h3>Build Strong Connections</h3>
            <p>
              Create powerful relationships with like-minded business owners
              ready to support your growth.
            </p>
          </div>

          <div className={styles.whyCard}>
            <h3>Get Quality Referrals</h3>
            <p>
              BNI members worldwide pass millions of referrals every year,
              generating billions in revenue.
            </p>
          </div>

          <div className={styles.whyCard}>
            <h3>Lifelong Learning</h3>
            <p>
              Access workshops, training, and mentorship to grow personally and
              professionally.
            </p>
          </div>
        </div>
      </section>

      {/* STATS (Now a separate component) */}
      <HomeStats />
    </div>
  );
}
